'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');
var InspectorSelectbox = require('../inspector/inspector__selectbox.js');

/**
 * Creates a Grid Tool which contains controls 
 *
 * @class
 */

class SnapTool extends Core {
 
    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'value': '1'
            }
        };
    }
    
    constructor(options) {
        super(options);
        
        this.template = `
            <div class='editor__grid_tool rightSlide'></div>
        `;

        super.render();

        var items = [{
            name: 'Off',
            value: '0'
        },{
            name: '0.1',
            value: '0.1'
        },{
            name: '0.25',
            value: '0.25'
        },{
            name: '0.50',
            value: '0.5'
        },{
            name: '1',
            value: '1'
        },{
            name: '2',
            value: '2'
        },{
            name: '5',
            value: '5'
        }];

        this.dropdown = new InspectorSelectbox({
            target: this.$el,
            fields: {
                'title': 'Snap grid',
                'options': items
            }
        }, false);
        this.dropdown.setValue(options.fields.value);


        /**
         * Click event
         *
         * @fires ToolbarTool#_clicked
         */

         $(this.dropdown.$el).on('Cioui:Inspector:value', this._clicked);
    }

    /**
     * @event ToolbarTool#Cioui:ToolbarTool:clicked
     * @property {String}Cioui:ToolbarTool:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e,value){
        //e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SnapTool:clicked', value);
    }

    /**
     * Makes the tool button active
     */

    setActive(){
        $('.js-editor__grid_tool', this.$el).addClass('active');
    }

    /**
     * Makes the tool button inactive
     */

    setInActive(){
        $('.js-editor__grid_tool', this.$el).removeClass('active');
    }

    positionToggle(){
        if(this.$el.hasClass('toggled'))
            this.$el.removeClass('toggled');
        else
            this.$el.addClass('toggled');
    }
}
module.exports = SnapTool;